export enum LoginType {
  PASSWORD = "PASSWORD",
  PASSCODE = "PASSCODE"
}